import React from "react";
import PouchSelect from "components/PouchSelect";
import { useMeet } from "util/useMeet";
import get from "lodash/get";
import { getScoreByOptions } from "util/options";
import range from "lodash/range";
import PouchCheckbox from "components/PouchCheckbox";
import PouchInput from "components/PouchInput";
import {
  TEAM_SCORING_FORMULA_DEFAULT,
  TEAM_SCORING_MAX_LIFTERS_DEFAULT,
  TEAM_SCORING_METHOD_DEFAULT,
  TEAM_SCORING_POINTS_MAP_DEFAULT,
} from "util/teamScoring";

const TeamScoring = () => {
  const meet = useMeet();

  return (
    <div className="entry-config">
      <div className="registration-title">Team Scoring</div>
      <div className="entry-row">
        <label style={{ width: 200 }}>Hide Team Scoring:</label>
        <div style={{ width: 100 }}>
          <PouchCheckbox
            meetId={meet._id}
            documentId={meet._id}
            name="hideTeamScoring"
            value={get(meet, "hideTeamScoring", false)}
          />
        </div>
      </div>
      <div className="entry-row">
        <label style={{ width: 200 }}>Team Scoring Method:</label>
        <div style={{ width: 150 }}>
          <PouchSelect
            meet={meet}
            document={meet}
            name="teamScoringMethod"
            value={get(meet, "teamScoringMethod", TEAM_SCORING_METHOD_DEFAULT)}
            options={() => [
              { label: "By Formula", value: "BY_FORMULA" },
              { label: "By Placing", value: "BY_PLACING" },
            ]}
            clearable={false}
          />
        </div>
      </div>
      <div>
        {meet.teamScoringMethod !== "BY_FORMULA" ? (
          <>
            Lifters are awarded points based on their placing in their primary
            division. The top performing lifters will have their points added up
            to form a team score. In the case of a tie the team with the most
            1st place, 2nd place, etc... will be win. If the placings still
            result in a tie then the final tie breaker will be that the top
            performing lifters will have their formula values added together to
            create a team tie breaker score.
          </>
        ) : (
          <>
            The top performing lifters up to will have their formula values
            added together to create a team score. In the case of a tie the team
            with the most 1st place, 2nd place, etc... will be win.
          </>
        )}
        Only the top lifters per team (configured by "Max Lifters Per Team"
        setting) will count towards the team's score.
      </div>
      <div className="entry-row">
        <label style={{ width: 200 }}>
          {meet.teamScoringMethod === "BY_FORMULA"
            ? "Team Scoring Formula"
            : "Tie Breaker Formula"}
          :
        </label>
        <div style={{ width: 250 }}>
          <PouchSelect
            meet={meet}
            document={meet}
            name="teamScoringFormula"
            value={get(
              meet,
              "teamScoringFormula",
              TEAM_SCORING_FORMULA_DEFAULT
            )}
            options={getScoreByOptions}
            clearable={false}
          />
        </div>
      </div>
      <div className="entry-row">
        <label style={{ width: 200 }}>Max Lifters Per Team:</label>
        <div style={{ width: 100 }}>
          <PouchSelect
            meet={meet}
            document={meet}
            name="teamScoringMaxLifters"
            value={get(
              meet,
              "teamScoringMaxLifters",
              TEAM_SCORING_MAX_LIFTERS_DEFAULT
            )}
            options={() => {
              return range(1, 21).map((num) => ({
                label: String(num),
                value: num,
              }));
            }}
            clearable={false}
          />
        </div>
      </div>
      <div className="entry-row">
        <label style={{ width: 200 }}>Divide Teams By Gender:</label>
        <div style={{ width: 100 }}>
          <PouchCheckbox
            meetId={meet._id}
            documentId={meet._id}
            name="teamScoringDivideByGender"
            value={get(meet, "teamScoringDivideByGender", true)}
          />
        </div>
      </div>
      {meet.teamScoringMethod !== "BY_FORMULA" && (
        <>
          {range(9).map((i) => {
            const position = i + 1;
            return (
              <div key={i} className="entry-row">
                <label style={{ width: 200 }}>
                  Points for placing {position}:
                </label>
                <div style={{ width: 100 }}>
                  <PouchInput
                    type="number"
                    meetId={meet._id}
                    documentId={meet._id}
                    name={["teamScoringPlacingValues", position]}
                    value={get(
                      meet,
                      ["teamScoringPlacingValues", position],
                      TEAM_SCORING_POINTS_MAP_DEFAULT[position] ?? 1
                    )}
                  />
                </div>
              </div>
            );
          })}
          <div>All placings greater than 9th will receive 1 point.</div>
        </>
      )}
    </div>
  );
};

export default TeamScoring;
